<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8">
      <SignInForm></SignInForm>
    </v-col>
  </v-row>
</template>

<script>
import SignInForm from "@/components/auth/SignInForm.vue";

export default {
  props: {},
  components: {
    SignInForm,
  },
};
</script>